module.exports = __webpack_public_path__ + "static/media/halifaxlogo.ac9703f3.jpeg";